// Mock data for Jagratha SHG website

export const groupInfo = {
  name: "Jagratha SHG",
  tagline: "Empowering Lives, Building Stronger Communities",
  description: "A leading self-help group, Jagratha is a community-driven collective affiliated with Kolping India, dedicated to fostering financial stability, skill development, and mutual growth. Through collective effort and shared values, we aim to create a sustainable and self-reliant community.",
  aboutus: "Jagratha is a self-help group dedicated to fostering financial stability, skill development, and mutual growth. Through collective effort and shared values, we aim to create a sustainable and self-reliant community.",
  bannerImage: "/images/hero-banner-1.jpg",
  mission: "To promote financial inclusion, skill enhancement, and collective empowerment through collaboration and mutual trust under the guidance of Kolping India.",
  vision: "A self-reliant community where every individual has the opportunity to grow economically, socially, and spiritually through cooperative action."
};

export const leadershipTeam = [
  {
    id: 1,
    name: "Sebastian M J",
    position: "President",
    image: "/images/sebastian-mj.jpg",
    description: "Leading the group with vision and dedication since 2024"
  },
  {
    id: 2,
    name: "Francis T",    
    position: "Vice President",
    image: "/images/francis-t.jpg",
    description: "Supporting organizational growth and member welfare"
    
  },
  {
    id: 3,
    name: "Prince K G",
    position: "Secretary",
    image: "/images/prince.jpg",
    description: "Managing documentation and member communications"
  },  
  {
    id: 4,
    name: "Yesudas",
    position: "Joint Secretary",
    image: "/images/yesudas.jpg",
    description: "Help organize and schedule group meetings"
  }, 
  {
    id: 5,
    name: "Boban K",
    position: "Treasurer",
    image: "/images/boban.jpg",
    description: "Overseeing financial operations and digital bookkeeping"
  }
];

export const newsEvents = [   
  {
    id: 1,
    title: "Onam Celebration 2025",
    shortDescription: "Celebrated the vibrant festival of Onam with traditional rituals, floral decorations, cultural performances, and a grand Onam Sadya feast.",
    fullDescription: "The Onam Celebration 2025 was a magnificent event filled with traditional Kerala festivities. Members came together to create beautiful Pookalam (floral rangoli) decorations, performed traditional dances like Thiruvathira and Pulikali, and organized cultural programs showcasing Kerala's rich heritage. The highlight was the grand Onam Sadya feast served on banana leaves, featuring traditional delicacies. The celebration fostered community bonding and preserved our cultural traditions while welcoming the spirit of King Mahabali.",
    thumbnail: "https://ik.imagekit.io/xn1o89qufm/jagratha/website/onam-2025-pookkalam-1.jpg?updatedAt=1761155739601",
    images: [
      "https://ik.imagekit.io/xn1o89qufm/jagratha/website/onam-2025-pookkalam-3.jpg?updatedAt=1761155740273",
      "https://ik.imagekit.io/xn1o89qufm/jagratha/website/onam-2025-pookkalam-2.jpg?updatedAt=1761155740216",
      "https://ik.imagekit.io/xn1o89qufm/jagratha/website/onam-2025-pookkalam-4.jpg?updatedAt=1761155740181",
      "https://ik.imagekit.io/xn1o89qufm/jagratha/website/onam-2025-meeting-1.jpg?updatedAt=1761154891247",
      "https://ik.imagekit.io/xn1o89qufm/jagratha/website/onam-2025-honoring-3.jpg?updatedAt=1761155740180",
      "https://ik.imagekit.io/xn1o89qufm/jagratha/website/onam-2025-honoring-vd.jpg?updatedAt=1761155740131",
      "https://ik.imagekit.io/xn1o89qufm/jagratha/website/onam-2025-honoring-2.jpg?updatedAt=1761155740115",
      "https://ik.imagekit.io/xn1o89qufm/jagratha/website/onam-2025-honoring-1.jpg?updatedAt=1761154891124",
    ],
    date: "2025-09-15",
    category: "Festival",
    featured : true
  },
  {
    id: 2,
    title: "Skill Development Workshop",
    shortDescription: "Organized a one-day workshop on innovative business ideas and locally sourced raw materials, empowering our 25 members with new skills for income generation.",
    fullDescription: "A comprehensive one-day skill development workshop was successfully organized, focusing on innovative business ideas and locally sourced raw materials, handicrafts, and entrepreneurship. 25 members actively participated and gained valuable skills that will help them start their own micro-enterprises. The workshop included hands-on training, business planning sessions, and market linkage guidance.",
    thumbnail: "https://ik.imagekit.io/xn1o89qufm/jagratha/website/weekly-meeting-with-kolping-melvin.jpg?updatedAt=1761154891191",
    images: [
      "https://ik.imagekit.io/xn1o89qufm/jagratha/website/weekly-meeting-with-kolping-melvin.jpg?updatedAt=1761154891191",
      "https://ik.imagekit.io/xn1o89qufm/jagratha/website/weekly-meeting-with-kolping-member.jpg?updatedAt=1761154891163",
      "https://ik.imagekit.io/xn1o89qufm/jagratha/website/weekly-meeting-with-priest-1.jpg?updatedAt=1761154891076"      
    ],
    date: "2025-03-10",
    category: "Event",
    featured : true
  },
  {
    id: 3,
    title: "Financial Literacy Program",
    shortDescription: "Launched a monthly financial literacy program to educate members about savings, investments, and digital banking.",
    fullDescription: "Understanding the importance of financial literacy, Jagratha SHG has launched a comprehensive monthly program covering topics such as savings strategies, investment options, digital banking, insurance, and financial planning. | Expert speakers and banking, insurance professionals are invited to conduct interactive sessions. The program aims to enhance members' financial decision-making capabilities and promote better money management practices.",
    thumbnail: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=400&h=300&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=800&h=600&fit=crop"
    ],
    date: "2025-05-12",
    category: "Program",
    featured : true
  },  
  {
    id: 4,
    title: "Community Health Camp",
    shortDescription: "Free health checkup camp organized in collaboration with local healthcare providers, benefiting 200+ community members.",
    fullDescription: "Jagratha SHG organized a free community health camp in partnership with local healthcare providers. The camp offered free health screenings, consultations, and awareness sessions on preventive healthcare. Over 200 community members, including SHG members and their families, benefited from this initiative. The event also included distribution of free medicines and health education materials.",
    thumbnail: "https://ik.imagekit.io/xn1o89qufm/jagratha/website/health-camp-1.jpg",
    images: [
      "https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=800&h=600&fit=crop",
      "https://ik.imagekit.io/xn1o89qufm/jagratha/website/health-camp-1.jpg"
    ],
    date: "2025-04-05",
    category: "Event",
    featured : false
  },  
  {
    id: 5,
    title: "Digital Transformation Success",
    shortDescription: "Jagratha SHG has implemented a digital bookkeeping system and a dedicated mobile app for its members, setting a new standard for self-help groups.",
    fullDescription: "In a groundbreaking achievement, Jagratha SHG is setting a new precedent for self-help groups with its implementation of comprehensive digital bookkeeping and a member-focused mobile app. The app provides members with digital passbooks, real-time transaction updates, and instant access to their savings and loan information. This innovation has significantly improved transparency and operational efficiency.",
    thumbnail: "https://ik.imagekit.io/xn1o89qufm/jagratha/website/jagratha-app-photo-1.jpg?updatedAt=1761157045501",
    images: [
      "https://ik.imagekit.io/xn1o89qufm/jagratha/website/jagratha-app-photo-1.jpg?updatedAt=1761157045501",
      "https://images.unsplash.com/photo-1563986768609-322da13575f3?w=800&h=600&fit=crop"
    ],
    date: "2025-02-20",
    category: "Innovation",
    featured : true
  },
  {
    id: 6,
    title: "Annual General Meeting 2025",
    shortDescription: "Successfully conducted our annual meeting with 100% member attendance and discussed growth strategies for the coming year.",
    fullDescription: "The Annual General Meeting of Jagratha SHG was held with remarkable success, witnessing 100% member participation. The meeting covered financial reports, future initiatives, and member welfare programs. Key decisions were made regarding expansion of digital services and new skill development programs.",
    thumbnail: "https://ik.imagekit.io/xn1o89qufm/jagratha/website/general-body-meeting.jpg",
    images: [
      "https://ik.imagekit.io/xn1o89qufm/jagratha/website/general-body-meeting.jpg",
      "https://ik.imagekit.io/xn1o89qufm/jagratha/website/general-body-meeting-2.jpg"      
    ],
    date: "2025-01-15",
    category: "Event",
    featured : true
  },
  {
    id: 7,
    title: "Kolping Augsburg Germany Delegation Visits St. Andrew's Basilica",
    shortDescription: "Kolping Augsburg Diocesan distinguished members visited the Kolping Alappuzha unit at St. Andrew's Basilica.",
    fullDescription: "Kolping Diocesan President Mr. Wolfgang Kretschmer, Chairman of the Kolping Society Augsburg Mr. Robert Hitzelberger, and five other distinguished members visited the Kolping Alappuzha unit at St. Andrew's Basilica. | During the gathering, the Jagratha Group proudly showcased and demonstrated our newly developed mobile application designed for efficient group management activities. | The delegates from Augsburg engaged in an interactive discussion with our members and expressed their appreciation for the initiative. As a token of goodwill, all participants received commemorative button badges from the visiting team. | The event also featured an insightful address by Rev.Fr Yesudas Kattungalthayil, who spoke about the rich history and various activities of the Arthunkal Basilica",
    thumbnail: "https://ik.imagekit.io/xn1o89qufm/jagratha/website/kolping-augsberg-visit-3.avif",
    images: [
      "https://ik.imagekit.io/xn1o89qufm/jagratha/website/kolping-augsberg-visit-2.avif",
      "https://ik.imagekit.io/xn1o89qufm/jagratha/website/kolping-augsberg-visit-4.avif"
    ],
    date: "2025-11-19",
    category: "Program",
    featured : true
  },  
  
];

export const galleryImages = [
  {
    id: 1,
    url: "https://ik.imagekit.io/xn1o89qufm/jagratha/website/weekly-meeting-with-kolping-melvin.jpg?updatedAt=1761154891191",
    title: "Group Meeting",
    category: "Meetings"
  },
   {
    id: 3,
    url: "https://ik.imagekit.io/xn1o89qufm/jagratha/website/weekly-meeting-with-priest-1.jpg?updatedAt=1761154891076",
    title: "Skill Development Workshop",
    category: "Training"
  },
  {
    id: 2,
    url: "https://ik.imagekit.io/xn1o89qufm/jagratha/website/weekly-meeting-with-kolping-member.jpg?updatedAt=1761154891163",
    title: "Annual General Meeting",
    category: "Events"
  },
 
  {
    id: 4,
    url: "https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=800&h=600&fit=crop",
    title: "Health Camp",
    category: "Community Service"
  },
  {
    id: 5,
    url: "https://ik.imagekit.io/xn1o89qufm/jagratha/website/jagratha-welcoming-new-priest-1.jpg?updatedAt=1761154891115",
    title: "Welcoming Fr. Sijo P Job",
    category: "Events"
  },
  
  {
    id: 7,
    url: "https://ik.imagekit.io/xn1o89qufm/jagratha/website/weekly-meeting-with-kolping-member.jpg?updatedAt=1761154891163",
    title: "Training Session",
    category: "Training"
  },
  {
    id: 8,
    url: "https://ik.imagekit.io/xn1o89qufm/jagratha/website/honoring-merti-scholorship-aagia.jpg?updatedAt=1761154890763",
    title: "Group Activity",
    category: "Activities"
  },
  {
    id: 9,
    url: "https://ik.imagekit.io/xn1o89qufm/jagratha/website/honoring-merti-scholorship-0.jpg?updatedAt=1761197004412",
    title: "Group Activity",
    category: "Activities"
  },
  {
    id: 10,
    url: "https://ik.imagekit.io/xn1o89qufm/jagratha/website/honoring-merti-scholorship-1.jpg?updatedAt=1761154891107",
    title: "Group Activity",
    category: "Activities"
  },  
  {
    id: 11,
    url: "https://ik.imagekit.io/xn1o89qufm/jagratha/website/honoring-merti-scholorship-31.jpg?updatedAt=1761197004766",
    title: "Group Activity",
    category: "Events"
  },
  {
    id: 12,
    url: "https://ik.imagekit.io/xn1o89qufm/jagratha/website/honoring-merti-scholorship.jpg?updatedAt=1761197004859",
    title: "Group Activity",
    category: "Events"
  },
  {
    id: 13,
    url: "https://ik.imagekit.io/xn1o89qufm/jagratha/website/honoring-melvin-0.jpg?updatedAt=1761197004815",
    title: "Group Activity",
    category: "Events"
  },
  {
    id: 14,
    url: "https://ik.imagekit.io/xn1o89qufm/jagratha/website/d3b864ad-0501-4edb-bddf-a181dbf8fa93.jpg?updatedAt=1761197004828",
    title: "Group Activity",
    category: "Events"
  },
  {
    id: 15,
    url: "https://ik.imagekit.io/xn1o89qufm/jagratha/website/onam-2025-pookkalam-3.jpg?updatedAt=1761155740273",
    title: "Group Activity",
    category: "Events"
  },
  {
    id: 16,
    url: "https://ik.imagekit.io/xn1o89qufm/jagratha/website/onam-2025-pookkalam-2.jpg?updatedAt=1761155740216",
    title: "Group Activity",
    category: "Events"
  },
  {
    id: 17,
    url: "https://ik.imagekit.io/xn1o89qufm/jagratha/website/onam-2025-pookkalam-4.jpg?updatedAt=1761155740181",
    title: "Group Activity",
    category: "Events"
  },
  {
    id: 18,
    url: "https://ik.imagekit.io/xn1o89qufm/jagratha/website/onam-2025-pookkalam-5.jpg?updatedAt=1761155740075",
    title: "Group Activity",
    category: "Events"
  },
  {
    id: 19,
    url: "https://ik.imagekit.io/xn1o89qufm/jagratha/website/onam-2025-honoring-2.jpg?updatedAt=1761155740115",
    title: "Group Activity",
    category: "Events"
  },
  {
    id: 20,
    url: "https://ik.imagekit.io/xn1o89qufm/jagratha/website/onam-2025-honoring-vd.jpg?updatedAt=1761155740131",
    title: "Group Activity",
    category: "Events"
  },
  {
    id: 21,
    url: "https://ik.imagekit.io/xn1o89qufm/jagratha/website/onam-2025-honoring-3.jpg?updatedAt=1761155740180",
    title: "Group Activity",
    category: "Events"
  },
  {
    id: 22,
    url: "https://ik.imagekit.io/xn1o89qufm/jagratha/website/onam-2025-honoring-1.jpg?updatedAt=1761154891124",
    title: "Group Activity",
    category: "Events"
  }
];

export const innovation = {
  title: "Digital Innovation Leader",
  description: "Jagratha SHG embraces digital excellence with our advanced bookkeeping and management systems, setting new standards for self-help group operations.. Our innovative approach includes a dedicated mobile application that provides members with digital passbooks, enabling them to track their savings, loans, and transactions in real-time.",
  features: [
    {
      title: "Digital Passbook",
      description: "Members can access their complete financial records anytime, anywhere through our mobile app."
    },
    {
      title: "Real-time Updates",
      description: "Instant notifications for all transactions, ensuring complete transparency."
    },
    {
      title: "Secure & Reliable",
      description: "Enterprise-grade security measures to protect member data and financial information."
    },
    {
      title: "Easy Management",
      description: "Simplified loan applications, repayment tracking, expenses and savings management."
    }
  ],
  appLink: "https://play.google.com/store/apps/details?id=com.qualisinfosys.shg"
};

export const contactInfo = {
  email: "jagrathashg@selfhelpgroups.in",
  phone: "+91 98765 43210",
  address: "Jagratha SHG Office, Community Hall, Kerala, India",
  socialMedia: {
    facebook: "#",
    twitter: "#",
    instagram: "#"
  }
};
